import React from 'react'
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { doc, updateDoc } from 'firebase/firestore';
import { useFirestore, useFirestoreDocData } from 'reactfire';

import Button from "antd/lib/button";

import useStorage from "../hooks/useStorage";
import AdvertisementForm from '../components/advertisement.form';

const EditAdvertisement = () => {
    const db = useFirestore();
    const { id } = useParams();
    const navigate = useNavigate();
    const ref = doc(db, "advertisement", id);
    const { uploadToStorage } = useStorage()

    const [loading, setLoading] = React.useState(false);
    const { status, data: advertisement } = useFirestoreDocData(ref);

    if (status === "loading") {
        return <p>Loading</p>
    }

    const submit = async (values) => {
        try {
            const { image } = values
            // if there is an image and it is not an URL we have to update it
            if (image && typeof(image) !== "string") {
                const file = image
                const url = await uploadToStorage("advertisement", id, file)
                values.image = url
            }
            await updateDoc(ref, values)
            navigate(-1)
        } catch(error) {
            console.error(error)
        }
    }

  return (
        <>
            <AdvertisementForm 
                title="Editar Cargador"
                loading={loading}
                buttonText="Actualizar"
                submit={submit}
                initialValues={advertisement}
                setLoading={setLoading}
            />
            <Button disabled={loading} onClick={() => navigate(-1)} block>Regresar</Button>
        </>
  )
}

export default EditAdvertisement